import React from 'react';

const TitleBarContext = React.createContext(false);

export default TitleBarContext;
